<div class="page-section">
  <div class="section-content">
    <div class="sections">
      <div class="section">
        <h4>Contact</h4>

        <a href="mailto:contact@mycardprofessor.com"
          >contact&#64;mycardprofessor.com</a
        >
        <a href="tel:+12243012273">+1 (224) 301-2273</a>
      </div>
      <div class="section">
        <h4>Legal</h4>
        <a [href]="customerAppURLBase + '/terms-of-service'"
          >Terms of Service</a
        >
        <a [href]="customerAppURLBase + '/privacy-policy'">Privacy Policy</a>
      </div>
    </div>

    <p>&copy; 2026 The Card Professor Inc.</p>
  </div>
</div>
